var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92356 20.0002H2.06641V7.14307H5.92356V20.0002ZM20.0665 20.0002H16.2093V13.1319C16.2093 11.3422 15.5716 10.4512 14.3077 10.4512C13.3062 10.4512 12.671 10.9501 12.3521 11.9491V20.0002H8.495C8.495 20.0002 8.54642 8.42878 8.495 7.14307H11.5396L11.7749 9.7145H11.8546C12.6453 8.42878 13.9092 7.55707 15.6423 7.55707C16.9602 7.55707 18.026 7.9235 18.8399 8.84407C19.6589 9.76593 20.0665 11.0028 20.0665 12.7398V20.0002Z",
    fill: "#23242F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99286 5.85715C5.09349 5.85715 5.98573 4.9937 5.98573 3.92858C5.98573 2.86345 5.09349 2 3.99286 2C2.89224 2 2 2.86345 2 3.92858C2 4.9937 2.89224 5.85715 3.99286 5.85715Z",
    fill: "#23242F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1def931cf79042e703019355133479ba.svg";
export { ForwardRef as ReactComponent };